import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 268.832 268.832" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M265.171 125.577l-80-80c-4.881-4.881-12.797-4.881-17.678 0-4.882 4.882-4.882 12.796 0 17.678l58.661 58.661H12.5c-6.903 0-12.5 5.597-12.5 12.5 0 6.902 5.597 12.5 12.5 12.5h213.654l-58.659 58.661c-4.882 4.882-4.882 12.796 0 17.678 2.44 2.439 5.64 3.661 8.839 3.661s6.398-1.222 8.839-3.661l79.998-80c4.882-4.882 4.882-12.796 0-17.678z",
    fill: "currentColor"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

import router from '@/router';

interface Props {
    reveres?: boolean
    colorIcon : string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BackFlash',
  props: {
    reveres: { type: Boolean },
    colorIcon: null
  },
  setup(__props: any) {

const props = __props as {
    reveres?: boolean
    colorIcon : string
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center justify-center p-1 w-10 h-10 cursor-pointer", { 'rotate-180': __props.reveres }])
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(["w-8", __props.colorIcon])
    }, _hoisted_2, 2)
  ], 2))
}
}

})